import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-paises',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-paises-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-paises-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-paises-index" */ '@/modules/configurations/catalogs/catalog-paises/views/Index.vue')
        }
    ]
}
